import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAgitatorPropeller = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 92.74,
	height: 132.12,
	viewBox: "0 0 92.74 132.12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 46.37 0.0 L 46.37 120.0 M 76.37 110.0 A 11.0 11.0 0.0 1 1 76.37 130.0 L 16.37 110.0 A 11.0 11.0 0.0 1 0 16.37 130.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgAgitatorPropeller;
